// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = "/";
const ROOTS_AUTH = "/auth";

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, "app"),
    group: path(ROOTS_DASHBOARD, "group"),
    pager: path(ROOTS_DASHBOARD, "pager"), // New pager path
    call: path(ROOTS_DASHBOARD, "call"), // Call path, shifted
    settings: path(ROOTS_DASHBOARD, "settings"), // Settings path, shifted
    profile: path(ROOTS_DASHBOARD, "profile"), // Profile path, shifted
    broadcastMessages: path(ROOTS_DASHBOARD, "broadcast-messages"), // New broadcast messages path
    resources: path(ROOTS_DASHBOARD, "resources"), // New resources path
    chatAppearance: path(ROOTS_DASHBOARD, "settings/chat-appearance"), // New chat appearance settings path
    changePassword: path(ROOTS_DASHBOARD, "settings/change-password"), // New change password settings path
    adjustFontSize: path(ROOTS_DASHBOARD, "settings/adjust-font-size"), // New adjust font size settings path
    appConfiguration: path(ROOTS_DASHBOARD, "settings/app-configuration"), // New app configuration settings path
    departmentSchedule: path(ROOTS_DASHBOARD, "settings/department-schedule"), // New department schedule path
  },
};

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, "/login"),
};

// PATH_DASHBOARD.general.app => "/"+"app" => /app
// PATH_DASHBOARD.general.group => "/"+"group" => /group